import {
  createRouter,
  RouteRecordRaw,
  NavigationGuardNext,
  createWebHashHistory,
  RouteLocationNormalized,
  createWebHistory
} from 'vue-router'
import { Modal } from 'ant-design-vue'

import store, { MutationTypes } from '@/store'
import { ssoAnthConfig } from '@/config/app-config'
import menu, { MenuType, MenuChildern } from './menu'
import UserManager from '@/user/UserManager'
import { queryString } from '@/utils'

let route: RouteRecordRaw[] = []

const defaultRouter: RouteRecordRaw[] = [
  {
    path: '/Account/LoginCallback',
    name: 'Login',
    meta: {
      requireAuth: false,
      showLayout: false
    },
    component: () => import('@/view/SSO/LoginCallBack')
  },
  {
    path: '/Home',
    name: 'Home',
    meta: {
      requireAuth: true
    },
    component: () => import('@/view/Home')
  },
  // {
  //   path: "/",
  //   meta: {
  //     requireAuth: false
  //   },
  //   redirect: '/OperateAnalysis/Reorder/ReorderHistorySummary'
  // },
  {
    path: '/',
    name: 'ChangeLog',
    meta: {
      requireAuth: false,
      showLayout: true,
      isDoc: true
    },
    component: () => import('@/vueDoc/change-log.md')
  },
  {
    path: '/changeLogOld',
    name: 'ChangeLogOld',
    meta: {
      requireAuth: false,
      showLayout: true,
      isDoc: true
    },
    component: () => import('@/view/changelog')
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    meta: {
      requireAuth: false
    },
    component: () => import('@/view/404')
  }
]

// 拍平menu，在事实上不存在嵌套关系，仅菜单形式上存在
const flatMenu = (config: MenuType[]) => {
  config.map((item) => {
    if (!item.children) {
      return route.push(item as RouteRecordRaw)
    }
    return flatMenu(item.children as MenuType[])
  })
  return route
}

const routes = flatMenu(menu)

const router = createRouter({
  history: createWebHistory(),
  routes: [...routes, ...defaultRouter]
})

router.beforeEach(
  (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    if (to.meta?.goOld) {
      // window.open('https://a-webapi.didaadmin.com' + to.fullPath)
      window.location.href = 'https://a-webapi.didaadmin.com' + to.fullPath
      return
    }
    document.title = 'BI-' + (to.name as string)

    // 设置是否展示 layout
    store.commit(MutationTypes.SET_LAYOUT, !(to.meta && to.meta.showLayout === false))
    if (to.meta.requireAuth !== false) {
      // 页面需要鉴权

      if (to.meta.searchAuth) {
        // url参数鉴权就不走 UserManager
        // next()
        const search = queryString(location.search)
        if (search && search.auth) {
          store.commit(MutationTypes.SET_USER, JSON.parse(decodeURI(search.auth)))
          store.commit(MutationTypes.SET_GLOBAL_LOADING, false)
          next()
          return
        }
      }
      if (!store.state.userInfo) {
        // 未登录
        store.commit(MutationTypes.SET_GLOBAL_LOADING, true)
        if (to.meta.showMenu === false) {
          UserManager.isGettingUserInfo = true // 不展示menu的话不需要获取user信息
        }
        UserManager.manager.getUser().then((user) => {
          if (!user) {
            UserManager.Login().finally(() => {
              store.commit(MutationTypes.SET_GLOBAL_LOADING, false)
              next()
            })
          } else if (!store.state.userRoute.includes(to.path)) {
            // 没有页面的权限
            store.commit(MutationTypes.SET_GLOBAL_LOADING, false)
            next({ name: '404' })
          } else {
            store.commit(MutationTypes.SET_GLOBAL_LOADING, false)
            next()
          }
        })
      } else if (!store.state.userRoute.includes(to.path)) {
        // 没有页面的权限
        store.commit(MutationTypes.SET_GLOBAL_LOADING, false)
        next({ name: '404' })
      } else {
        store.commit(MutationTypes.SET_GLOBAL_LOADING, false)
        next()
      }
    } else {
      if (to.meta.showLayout !== false && !store.state.userInfo) {
        // 未登录
        UserManager.manager.getUser().then((user) => {
          if (!user) {
            UserManager.Login()
          }
        }).catch(()=> {
          Modal.destroyAll()
          Modal.warning({
            title: 'Error',
            content: 'No Login Permission!'
          })
        })
      }
      store.commit(MutationTypes.SET_GLOBAL_LOADING, false)
      next()
    }

    // 设置是否展示 layout
    // store.commit(MutationTypes.SET_LAYOUT, !(to.meta && to.meta.showLayout === false))
    // next()
  }
)

// router.afterEach((to, from, failure) => {
//   console.log('router.afterEach', to, from)
//   if (to.meta.requireAuth !== false) { // 需要鉴权
//     if(!store.state.userInfo) { // 未登录
//       store.commit(MutationTypes.SET_GLOBAL_LOADING, true)
//       UserManager.manager
//         .getUser().then(user => {
//           console.log('useruseruseruseruseruseruser', user)
//           if (!user) {
//             UserManager.Login().finally(() => {
//               console.log('UserManager.Login().finally(')
//               store.commit(MutationTypes.SET_GLOBAL_LOADING, false)
//             })
//           } else if (!store.state.userRoute.includes(to.path)) {
//             router.push({ name: '404' })
//             store.commit(MutationTypes.SET_GLOBAL_LOADING, false)
//           } else {
//             store.commit(MutationTypes.SET_GLOBAL_LOADING, false)
//           }
//         })
//     } else if (!store.state.userRoute.includes(to.path)) {
//       router.push({ name: '404' })
//       store.commit(MutationTypes.SET_GLOBAL_LOADING, false)
//     }
//   } else {
//     store.commit(MutationTypes.SET_GLOBAL_LOADING, false)
//   }
// })

export default router
